(function() {
function socketio(sioc,oo) {
 if(!oo) oo = {};
 var L;
 if(oo.L) L = oo.L;
 else {
  L = ['trace','debug','info','warn','error','fatal'].reduce(function(p,c) {
   p[c] = function(d,m) {
    if(m) console.log(c+': '+m,d); //eslint-disable-line no-console
    else console.log(c+': '+d);    //eslint-disable-line no-console
   };
   return p;
  },{});
 }
 this.set_logger = function(l) { L=l; return this };

 var cbf = null;
 var socket = null;

 this.init = function(host,port,cb) {
  cbf = cb;

  var url = host;
  if(port != 0) url += (':'+port);
  socket = sioc?sioc(url):io(url);

  socket.on('status',function(data){
   L.trace({status:data.data},"socketio status");
   cbf['status'](data.data);
  });

  socket.on('data',function(data){
   cbf['data'](data.data.length?data.data:data.data.data);
  });
 };

 this.send = function(pdu) {
  socket.emit('data', {data: pdu});
 };

 this.shutdown = function() {
  if(socket.close) socket.close();
 };
}

if(typeof module !== 'undefined' && typeof module.exports !== 'undefined') module.exports = socketio;
else window.socketio = socketio;
})();
